import React from "react";
import ReactFlipCard from "reactjs-flip-card";


function FeaturesHomeEight() {
  const styles = {
    
    // cardWrapper: {
    //   width: "200px",
    //   height: "150px",
    //   perspective: "1000px", // helps with 3D flip depth
    // },
    card: {
      color: 'white', borderRadius: 20,
    },
  };
  return (
    <>
      <section
        className="appie-features-area-2 appie-features-area-5 pt-90 pb-100"
        id="solutions"
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <div className="appie-section-title text-center">
                <h3 className="appie-title">
                  Services we provide
                </h3>
                {/* <p>
                  The full monty spiffing good time no biggie cack grub
                  fantastic.
                </p> */}
              </div>
            </div>
          </div>
          
          
          <div className="row mt-30 align-items-center">
            <div className="col-lg-6">
              <div className="appie-features-boxes ">
                <div className="appie-features-box-item appie-features-box-5-item">
        {/* <ReactFlipCard
          frontStyle={{...styles.card, background: "rgb(0, 179, 173)",
  color: "white",
  borderRadius: "20px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",width: 500,}}
          backStyle={{...styles.card, background: "rgb(0, 179, 173)",
  color: "white",
  borderRadius: "20px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",width: 500,}}
          frontComponent={<h4 className="title">IPTV</h4>}
          backComponent={<p>IPTV (Internet Protocol Television): Distributing TV and AV
                    media across IT networks has become a vital element in the
                    way forward thinking organization’s communicate, disseminate
                    information and succeed. By broadcasting live TV, news
                    feeds, video and PowerPoint presentations, our financial,
                    healthcare, education and hospitality sector clients are
                    leading the way when it comes to using the power of TV over
                    IP to communicate key content to their audiences.</p>}
        /> */}
                  <h4 className="title">IPTV</h4>
                  <p>
                    IPTV (Internet Protocol Television): Distributing TV and AV
                    media across IT networks has become a vital element in the
                    way forward thinking organization’s communicate, disseminate
                    information and succeed. By broadcasting live TV, news
                    feeds, video and PowerPoint presentations, our financial,
                    healthcare, education and hospitality sector clients are
                    leading the way when it comes to using the power of TV over
                    IP to communicate key content to their audiences.
                    {/* <br />
With all content managed and distributed centrally, company information can easily be routed and viewed by pre-defined teams in selected departments or office locations, while sensitive data can be restricted to those who are authorized to see it. */}
                  </p>
                </div>
                 <div className="appie-features-box-item appie-features-box-5-item">
                  <h4 className="title">AI and IoT</h4>
                  <p>
                    AI sensors can create mountains of data, much of which has immediate value in process control and value in the sense of business analysis and optimization. The Internet of Things which is simply known as IOT consists of interlinking devices such as computer devices, digital machines, vehicles or any other physical objects having their own unique identifiers. They are capable of sending data through a network without person to person or machine to machine conversation. IOT is used in our household purposes with great effect.
                    {/* <br />IOT is used in our household purposes with great effect. It has created smart homes with a great security system and other positive features. One key use is automation compatible with mobile devices. A homeowner can control basic items like light bulb or fan and even the security system from his/ her smartphone. We also can control light or house lock. Hence it is getting very much popular in Dubai and other emirates of UAE. People of UAE are getting dependent on IOT day by day for their comfort.  */}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="appie-features-boxes ">
                <div className="appie-features-box-item appie-features-box-5-item">
                  <h4 className="title">Smart Booking</h4>
                  <p>
                    Booking rooms in advance to be ready for a meeting is called Room Booking. With a room booking system, people are able to search for and book a meeting room in advance, based on their needs and wishes. Employees can book meeting rooms, and invite colleagues and external visitors, together with their wishes for Catering & Services.Also it is possible to book your car parking space together with your desk or room booking in the Portal, the Mobile App, and via Mapping.
                    {/* <br />
Additionally, the content is not played from your phone or tablet. The device connected to the display (Google’s Chromecast, for example) downloads and plays the content on the TV. Once you have screen cast the content to the TV, you will need to control it from the TV and not your phone or personal device.
The term “casting” as it is currently used grew in popularity largely after the launch of Chromecast, and it quickly became the standard term for playing content on your TV from an app on your mobile device. Google’s Chromecast is one of the most popular streaming devices that is capable of casting and can be built into any number of apps. */}
                  </p>
                </div>
                <div className="appie-features-box-item appie-features-box-5-item">
                  <h4 className="title">Content Delivery</h4>
                  <p>
                    The gateway to better video delivery, is a rapidly growing technology that provides a broad range of innovative products and services enabling efficient, high-quality video delivery. Universe Media continues to meet the needs of modern media with a cutting-edge product portfolio, backed by best-in-industry support. We works in close collaboration with customers to provide solutions for the content delivery challenges of today and tomorrow, enabling them to deliver high-quality content throughout their networks.
                    {/* <br />IOT is used in our household purposes with great effect. It has created smart homes with a great security system and other positive features. One key use is automation compatible with mobile devices. A homeowner can control basic items like light bulb or fan and even the security system from his/ her smartphone. We also can control light or house lock. Hence it is getting very much popular in Dubai and other emirates of UAE. People of UAE are getting dependent on IOT day by day for their comfort.  */}
                  </p>
                </div>
              </div>
            </div>
                        <div className="col-lg-6">
              <div className="appie-features-boxes ">
                 <div className="appie-features-box-item appie-features-box-5-item">
                  <h4 className="title">Digital Signage</h4>
                  <p>
                    The age of digital comms has arrived, and with the industry
                    growing quickly, businesses not investing in digital signage
                    campaigns may soon find themselves left behind. Now is the
                    time to seriously think about using digital
                    signage campaigns to create experiences that influence the
                    way people interact with your business and to innovate your
                    marketing.
                    {/* <br />
Most players are capable of exactly the same thing: create, schedule, and playback content. Before you go jumping into an investment in Digital Signage solutions, it’s critical to first make sure you have a sound signage content strategy. What is the desired outcome from deploying digital signage, and do you have the appropriate plan, team, and support to keep content updated and relevant? */}
                  </p>
                </div>
              
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default FeaturesHomeEight;
